import React from "react"
import accessibleSvg from "src/utils/accessibleSvg"

export default accessibleSvg(({ children, ...props }) => (
  <svg
    fill="currentColor"
    viewBox="0 0 100 100"
    width="100"
    height="100"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {children}
    <path
      id="Filter"
      fillRule="evenodd"
      d="M50,100c49.614,0,50-22.386,50-50S99.614,0,50,0,0,22.386,0,50,0.386,100,50,100ZM74.375,61.294H25.625A1.651,1.651,0,0,0,24,62.971v3.352A1.651,1.651,0,0,0,25.625,68h48.75A1.651,1.651,0,0,0,76,66.323V62.971A1.651,1.651,0,0,0,74.375,61.294Zm-42.25-8.941h35.75A1.651,1.651,0,0,0,69.5,50.676V47.324a1.651,1.651,0,0,0-1.625-1.677H32.125A1.651,1.651,0,0,0,30.5,47.324v3.352A1.651,1.651,0,0,0,32.125,52.353Zm6.5-15.647h22.75A1.651,1.651,0,0,0,63,35.029V31.676A1.651,1.651,0,0,0,61.375,30H38.625A1.651,1.651,0,0,0,37,31.676v3.353A1.651,1.651,0,0,0,38.625,36.706Z"
    />
  </svg>
))
